import { Controller } from "@hotwired/stimulus"

// Switches the Email Content sidebar between the "Recipients" preview (default)
// and the "Reuse a previous email" picker, keeping only one visible at a time.
export default class extends Controller {
  static targets = ["recipientsPanel", "reusePanel", "recipientsTab", "reuseTab"]

  showRecipients() {
    this.activate(false)
  }

  showReuse() {
    this.activate(true)
  }

  activate(reuse) {
    this.recipientsPanelTarget.classList.toggle("hidden", reuse)
    if (this.hasReusePanelTarget) this.reusePanelTarget.classList.toggle("hidden", !reuse)

    this.setActive(this.recipientsTabTarget, !reuse)
    if (this.hasReuseTabTarget) this.setActive(this.reuseTabTarget, reuse)
  }

  setActive(tab, on) {
    tab.classList.toggle("bg-white", on)
    tab.classList.toggle("shadow-sm", on)
    tab.classList.toggle("text-gray-900", on)
    tab.classList.toggle("text-gray-500", !on)
  }
}
